<template>
  <div class="cashier-fee-summary-container">
    <!-- 搜索栏 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ $t('communityFeeSummary.cashierFeeSummary.search.title') }}</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-select
            v-model="searchForm.communityIds"
            multiple
            collapse-tags
            filterable
            clearable
            :placeholder="$t('communityFeeSummary.cashierFeeSummary.search.placeholderCommunity')"
            class="w-100"
          >
            <el-option
              v-for="item in communityList"
              :key="item.communityId"
              :label="item.name"
              :value="item.communityId"
            />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :placeholder="$t('communityFeeSummary.cashierFeeSummary.search.placeholderDateRange')"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            class="w-100"
          />
        </el-col>
        <el-col :span="6">
          <el-select
            v-model="searchForm.feeTypeCd"
            filterable
            clearable
            :placeholder="$t('communityFeeSummary.cashierFeeSummary.search.placeholderFeeType')"
            class="w-100"
          >
            <el-option
              v-for="item in feeTypeOptions"
              :key="item.statusCd"
              :label="item.name"
              :value="item.statusCd"
            >
              <span style="float: left">{{ item.statusCd }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.name }}</span>
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="text-right">
          <el-button type="primary" @click="handleSearch">{{ $t('communityFeeSummary.cashierFeeSummary.search.search') }}</el-button>
          <el-button @click="handleReset">{{ $t('communityFeeSummary.cashierFeeSummary.search.reset') }}</el-button>
        </el-col>
      </el-row>
    </el-card>

    <!-- 表格区域 -->
    <el-card class="box-card mt-20">
      <div class="table-toolbar">
        <el-button type="success" @click="handleExport" :loading="exportLoading">
          {{ $t('communityFeeSummary.cashierFeeSummary.export') }}
        </el-button>
      </div>
      <el-table :data="tableData" border style="width: 100%" v-loading="loading">
        <el-table-column type="index" width="60" align="center" :label="$t('common.index')" />
        <el-table-column
          prop="cashierName"
          :label="$t('communityFeeSummary.cashierFeeSummary.table.cashierName')"
          align="center"
          min-width="120"
        />
        <el-table-column
          prop="feeCount"
          :label="$t('communityFeeSummary.cashierFeeSummary.table.feeCount')"
          align="center"
          width="100"
        />
        <el-table-column
          prop="receivableAmount"
          :label="$t('communityFeeSummary.cashierFeeSummary.table.receivableAmount')"
          align="right"
          min-width="140"
        >
          <template slot-scope="scope">
            {{ formatMoney(scope.row.receivableAmount) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="receivedAmount"
          :label="$t('communityFeeSummary.cashierFeeSummary.table.receivedAmount')"
          align="right"
          min-width="140"
        >
          <template slot-scope="scope">
            {{ formatMoney(scope.row.receivedAmount) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="discountAmount"
          :label="$t('communityFeeSummary.cashierFeeSummary.table.discountAmount')"
          align="right"
          min-width="140"
        >
          <template slot-scope="scope">
            {{ formatMoney(scope.row.discountAmount) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="acctAmount"
          :label="$t('communityFeeSummary.cashierFeeSummary.table.acctAmount')"
          align="right"
          min-width="140"
        >
          <template slot-scope="scope">
            {{ formatMoney(scope.row.acctAmount) }}
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="mt-10 text-right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      />
    </el-card>
  </div>
</template>

<script>
import { queryCashierFeeSummary, exportCashierFeeSummary } from '@/api/report/cashierFeeSummaryApi'
import { getMyEnteredCommunitys } from '@/api/community/communityApi'

export default {
  name: 'CashierFeeSummaryList',
  data() {
    return {
      searchForm: {
        communityIds: [],
        dateRange: [],
        feeTypeCd: ''
      },
      communityList: [],
      feeTypeOptions: [],
      tableData: [],
      loading: false,
      exportLoading: false,
      pagination: {
        page: 1,
        row: 20,
        total: 0
      }
    }
  },
  created() {
    this.loadCommunities()
    this.loadFeeTypes()
  },
  methods: {
    async loadCommunities() {
      try {
        const res = await getMyEnteredCommunitys({ page: 1, row: 500 })
        this.communityList = res.communitys || []
      } catch (error) {
        console.error('Failed to load communities:', error)
      }
    },
    loadFeeTypes() {
      this.$store.dispatch('dict/getDict', {
        dictType: 'pay_fee_config',
        dictName: 'fee_type_cd'
      }).then(data => {
        this.feeTypeOptions = data
      })
    },
    buildParams() {
      const params = {
        communityIds: this.searchForm.communityIds ? this.searchForm.communityIds.join(',') : '',
        startDate: this.searchForm.dateRange ? this.searchForm.dateRange[0] : '',
        endDate: this.searchForm.dateRange ? this.searchForm.dateRange[1] : '',
        feeTypeCd: this.searchForm.feeTypeCd || '',
        page: this.pagination.page,
        row: this.pagination.row
      }
      return params
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchData()
    },
    handleReset() {
      this.searchForm = {
        communityIds: [],
        dateRange: [],
        feeTypeCd: ''
      }
      this.pagination.page = 1
      this.tableData = []
    },
    async fetchData() {
      try {
        this.loading = true
        const params = this.buildParams()
        const res = await queryCashierFeeSummary(params)
        if (res.data && res.data.code === 0) {
          const result = res.data.data
          this.tableData = result.data || []
          this.pagination.total = result.total || 0
        }
      } catch (error) {
        this.$message.error(this.$t('communityFeeSummary.cashierFeeSummary.fetchError'))
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    handleSizeChange(val) {
      this.pagination.row = val
      this.pagination.page = 1
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      this.fetchData()
    },
    formatMoney(value) {
      return Number(value || 0).toFixed(2)
    },
    async handleExport() {
      if (!this.searchForm.communityIds || this.searchForm.communityIds.length === 0) {
        this.$message.warning(this.$t('communityFeeSummary.cashierFeeSummary.pleaseSelectCommunity'))
        return
      }
      if (!this.searchForm.dateRange || this.searchForm.dateRange.length === 0) {
        this.$message.warning(this.$t('communityFeeSummary.cashierFeeSummary.pleaseSelectDateRange'))
        return
      }
      try {
        this.exportLoading = true
        const params = {
          pagePath: 'reportCashierFeeSummary',
          communityId: this.searchForm.communityIds.join(','),
          startDate: this.searchForm.dateRange[0],
          endDate: this.searchForm.dateRange[1],
          feeTypeCd: this.searchForm.feeTypeCd || ''
        }
        const res = await exportCashierFeeSummary(params)
        if (res.code === 0) {
          this.$message.success(this.$t('communityFeeSummary.cashierFeeSummary.exportSuccess'))
        } else {
          this.$message.error(res.msg || this.$t('communityFeeSummary.cashierFeeSummary.exportError'))
        }
      } catch (error) {
        this.$message.error(this.$t('communityFeeSummary.cashierFeeSummary.exportError'))
        console.error(error)
      } finally {
        this.exportLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cashier-fee-summary-container {
  padding: 20px;

  .box-card {
    margin-bottom: 20px;
  }

  .mt-20 {
    margin-top: 20px;
  }

  .mt-10 {
    margin-top: 10px;
  }

  .w-100 {
    width: 100%;
  }

  .text-right {
    text-align: right;
  }

  .table-toolbar {
    margin-bottom: 10px;
    text-align: right;
  }
}
</style>
